import { Container, Navbar, Dropdown } from "react-bootstrap";
import { Link } from "react-router-dom";
import Logo from "../../assets/images/THS-logo.png";
import avtar from "../../assets/images/User.png";
import menuIcon from "../../assets/images/menu-icon.svg";
import { GoChevronDown } from "react-icons/go";
import { RiKeyFill, RiLogoutCircleLine, RiPassportFill } from "react-icons/ri";
const Header = () => {
  function toggleLeftMenu() {
    var element: any = document.getElementById("vertical_menu");
    element.classList.toggle("open-menu");
  }
  return (
    <>
      <header className="site-header">
        <Container fluid className="header-nav">
          <Navbar expand="lg">
            <Navbar.Toggle aria-controls="basic-navbar-nav"  onClick={toggleLeftMenu} />

            <Navbar.Brand className="ms-2 py-0">
              <img src={Logo} width={83} className="header-logo" />
            </Navbar.Brand>

            <div className="d-flex align-items-center ms-auto gap-3">
              <Dropdown className="profile-dd">
                <Dropdown.Toggle>
                  <div className="d-flex gap-2 align-items-center">
                    <div>
                      <img
                        src={avtar}
                        width={35}
                        height={35}
                        className=" rounded-circle object-fit-cover"
                        alt=""
                      />
                    </div>
                    <div>
                      <p className="font-14 mb-0 text-dark font-medium me-2">
                        {localStorage.getItem("user_name")}
                      </p>
                    </div>
                  </div>
                  <GoChevronDown size={16} className="icon" />
                </Dropdown.Toggle>
                <Dropdown.Menu align="end">
                  {/* <Link to="" className=" dropdown-item"> <SlUser size={14} className="me-2" /> My Profile</Link> */}

                  {/* <Link to="/change-password" className=" dropdown-item" onClick={() => {
                  }}>

                    <RiKeyFill
                      size={14}
                      className="me-2"

                    />{" "}
                    Change Password
                  </Link> */}
                  <Link to="/login" className=" dropdown-item" onClick={() => {
                    localStorage.clear()
                  }}>

                    <RiLogoutCircleLine
                      size={14}
                      className="me-2"

                    />{" "}
                    Logout
                  </Link>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </Navbar>
        </Container>
      </header>
    </>
  );
};
export default Header;
